export default{"*.*.*":{"*.disappearing":[{finalAttr:{opacity:0},slot:'initial',callback:function(){this.hide()}}]}};


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-charts/src/chart/_internal/common.animation.js
// module id = null
// module chunks = 